import { useAuth } from '../../contexts/AuthContext';

export default function SessionTimeoutModal() {
  const { showSessionWarning, warningCountdown, extendSession, logout } = useAuth();

  if (!showSessionWarning) return null;

  const minutes = Math.floor(warningCountdown / 60);
  const seconds = warningCountdown % 60;
  const timeLabel = minutes > 0
    ? `${minutes}m ${seconds}s`
    : `${seconds}s`;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.iconWrap}>
          <span style={styles.icon}>⏱</span>
        </div>
        <h2 style={styles.title}>Session Expiring Soon</h2>
        <p style={styles.body}>
          You have been inactive. Your session will expire in
        </p>
        <div style={styles.countdown}>{timeLabel}</div>
        <p style={styles.sub}>Click "Stay Logged In" to continue your session.</p>
        <div style={styles.actions}>
          <button style={styles.btnStay} onClick={extendSession}>
            Stay Logged In
          </button>
          <button style={styles.btnLogout} onClick={logout}>
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  modal: {
    background: '#fff',
    borderRadius: 12,
    padding: '2rem 2.5rem',
    maxWidth: 400,
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  iconWrap: {
    marginBottom: '0.75rem',
  },
  icon: {
    fontSize: 48,
  },
  title: {
    margin: '0 0 0.5rem',
    fontSize: '1.25rem',
    fontWeight: 700,
    color: '#1a1a2e',
  },
  body: {
    margin: '0 0 0.25rem',
    color: '#555',
    fontSize: '0.95rem',
  },
  countdown: {
    fontSize: '2.5rem',
    fontWeight: 800,
    color: '#e53e3e',
    margin: '0.5rem 0',
    fontVariantNumeric: 'tabular-nums',
  },
  sub: {
    color: '#777',
    fontSize: '0.875rem',
    marginBottom: '1.5rem',
  },
  actions: {
    display: 'flex',
    gap: '0.75rem',
    justifyContent: 'center',
  },
  btnStay: {
    background: '#3b82f6',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '0.6rem 1.4rem',
    fontSize: '0.95rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnLogout: {
    background: '#f3f4f6',
    color: '#374151',
    border: '1px solid #d1d5db',
    borderRadius: 8,
    padding: '0.6rem 1.4rem',
    fontSize: '0.95rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
};
